import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconStudioDisplay: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconStudioDisplay"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4H22V18H16V21H8V18H2V4ZM9.5 18V19.5H14.5V18H9.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconStudioDisplay;
